import * as React from 'react'
import { richStringParser } from 'rich-string-parser'

import {
  MarkdownBoldParser,
  MarkdownBreakLineParser,
  MarkdownImageLinkParser,
  MarkdownItalicParser,
  MarkdownLinksParser,
} from '../lib/string-parsers/markdown-parsers'

export function markdownTransformer(texts: any[] | string) {
  if (!Array.isArray(texts)) {
    texts = [texts]
  }

  const components = texts
    .map((text) => {
      const parsed = richStringParser(text, [
        MarkdownBoldParser(),
        MarkdownItalicParser(),
        MarkdownImageLinkParser(),
        MarkdownLinksParser(),
        MarkdownBreakLineParser(),
      ])

      return parsed.map((data, index) => {
        if (typeof data === 'string') {
          return data
        }

        if (data.type === 'MarkdownLinksParser') {
          return (
            <a
              key={index}
              target="_blank"
              href={data.parts[1]}
              rel="noreferrer"
            >
              {data.parts[0]}
            </a>
          )
        }

        if (data.type === 'MarkdownImageLinkParser') {
          return <img key={index} src={data.parts[1]} alt={data.parts[0]} />
        }

        if (data.type === 'MarkdownBoldParser') {
          return <b key={index}>{data.result}</b>
        }

        if (data.type === 'MarkdownItalicParser') {
          return <i key={index}>{data.result}</i>
        }

        if (data.type === 'MarkdownBreakLineParser') {
          return <br key={index} />
        }

        return data
      })
    })
    .reduce((a, b) => a.concat(b), [])

  return components
}

type Props = {
  value: any[] | string
}

export const MarkdownTransformer: React.FC<Props> = ({ value }) => {
  const Components = markdownTransformer(value)
  return <>{Components}</>
}
